import * as json2csv from "json2csv";
import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import ReactLoading from "react-loading";

import ReactExport from "react-data-export"; //excel export
import * as moment from "moment";

import isEmpty from "../../lib/isEmpty";

import Griddle, {
  ColumnDefinition,
  RowDefinition,
  plugins,
} from "griddle-react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import tableStyle from "assets/jss/material-dashboard-react/components/tableStyle";

import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";

import { DateColumn, DateOnlyColumn } from "components/Table/TableRows.jsx";

import Dialog from "@material-ui/core/Dialog";

import httpr from "lib/httpRequest";
import { BASE_URL } from "lib/config";

import JSPdf from "jspdf";
import fileDownload from "react-file-download";
import { ERROR_LOG } from "../ReportOptions/ReportOptions";
import { Col } from "react-flexbox-grid";

const accounting = require("accounting");

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const NewLayout = ({ Table, Pagination, Filter }) => (
  <div>
    <Filter />
    <Table />
    <Pagination />
  </div>
);

const PrintLayout = ({ Table }) => (
  <div>
    <Table />
  </div>
);

const Denominations = () => (
  <RowDefinition>
    <ColumnDefinition id="Hundreds" title="Hundreds" />
    <ColumnDefinition id="Fifties" title="Fifties" />
    <ColumnDefinition id="Twenties" title="Twenties" />
    <ColumnDefinition id="Tens" title="Tens" />
    <ColumnDefinition id="Fives" title="Fives" />
    <ColumnDefinition id="Ones" title="Ones" />
    <ColumnDefinition id="Dollar Coins" title="Dollar Coins" />
    <ColumnDefinition id="Half Dollars" title="Half Dollars" />
    <ColumnDefinition id="Quarters" title="Quarters" />
    <ColumnDefinition id="Dimes" title="Dimes" />
    <ColumnDefinition id="Nickels" title="Nickels" />
    <ColumnDefinition id="Pennies" title="Pennies" />
  </RowDefinition>
)

class ReportTable extends React.Component {
  _isMounted = false;
  constructor(props) {
    super(props);

    this.state = {
      exportExcel: false,
      exportPDF: false,
      tableData: props.reportData.tableData,
      showLoading: true,
      tableTitle: props.reportData.tableInfo.tableTitle,
      tableSubTitle: props.reportData.tableInfo.tableSubTitle,
      tableType: props.reportData.tableInfo.tableType,
      tableId: props.reportData.tableInfo.tableId,
      isKisanReport: props.reportData.isKisanReport
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      tableData: nextProps.reportData.tableData,
      showLoading: nextProps.showLoading,
      tableTitle: nextProps.reportData.tableInfo.tableTitle,
      tableSubTitle: nextProps.reportData.tableInfo.tableSubTitle,
      tableType: nextProps.reportData.tableInfo.tableType,
      tableId: nextProps.reportData.tableInfo.tableId,
      isKisanReport: nextProps.reportData.isKisanReport
    });
  }

  componentDidMount() {
    this._isMounted = true;
    this.setState({
      tableData: this.props.reportData.tableData,
      showLoading: this.props.showLoading,
      tableTitle: this.props.reportData.tableInfo.tableTitle,
      tableSubTitle: this.props.reportData.tableInfo.tableSubTitle,
      tableType: this.props.reportData.tableInfo.tableType,
      tableId: this.props.reportData.tableInfo.tableId,
      isKisanReport: this.props.reportData.isKisanReport
    });
  }
  componentWillUnmount() {
    this._isMounted = false;
  }

  hanldeExportExcel = () => {
    this.setState({ exportExcel: true });
  };

  downloadExcel = () => {
    const { tableData, tableTitle } = this.state;
    let dataCol = <div />;

    if (tableData.length > 0) {
      const fields = Object.keys(tableData[0]);
      dataCol = fields.map((fieldName) => {
        //fieldName = fieldName.replace(/_/g, " ");
        //fieldName = fieldName.toUpperCase();
        return (
          <ExcelColumn key={fieldName} label={fieldName} value={fieldName} />
        );
      });
    }

    return (
      <ExcelFile hideElement={true}>
        <ExcelSheet data={tableData} name={tableTitle}>
          {dataCol}
        </ExcelSheet>
      </ExcelFile>
    );
  };

  handleExportPdf = () => {
    this.props.handleExportPdf();
  };

  savePdf = () => {
    const { tableTitle, tableId } = this.state;

    const fileName = `${tableTitle}.pdf`;

    const el = document.querySelector(`#${tableId}`);

    //const w = 960;

    //var doc = new JSPdf('p', 'mm', [el.clientWidth, el.clientHeight]);
    var doc = new JSPdf("p", "mm", [960, 960]);

    doc.fromHTML(el.innerHTML, 100, 10);

    doc.save(fileName);

    this.handleExportPdf();
  };

  handleExportCsv = () => {
    const { reportData } = this.props;
    this.props.handleExportCsv(reportData);
  };

  render() {
    const {
      tableTitle,
      tableSubTitle,
      tableType,
      tableId,
      tableData,
    } = this.state;
    const { classes, tableHeaderColor, showLoading } = this.props;

    const styleConfig = {
      icons: {
        TableHeadingCell: {
          sortDescendingIcon: <div />,
          sortAscendingIcon: <div />,
        },
      },
      classNames: {
        Table: `${classes.table}`,
        TableHeadingCell: `${classes.tableHeadCell}`,
        TableHeading: `${classes[tableHeaderColor + "TableHeader"]}`,
        Cell: `${classes.tableCell}`,
        Row: `${classes.tableRow}`,
      },
    };

    const AmountColumn = ({ value, griddleKey, data }) => {
      return <div>{accounting.formatMoney(value)}</div>;
    };
    const PercentCol = ({ value, griddleKey, tdata }) => {
      return <div>{Number.parseFloat(value).toFixed(1)}%</div>;
    };

    const rowDataSelector = (state, { griddleKey }) => {
      return state
        .get("data")
        .find((rowMap) => rowMap.get("griddleKey") === griddleKey)
        .toJSON();
    };

    const enhancedWithRowData = connect((state, props) => {
      return {
        // rowData will be available into MyCustomComponent
        rowData: rowDataSelector(state, props),
      };
    });

    let tableRowDef = <div />;

    if (tableType === "Usage_Totals") {
      if (this.state.isKisanReport === true) {
        tableRowDef = (
          <RowDefinition>
            <ColumnDefinition id="Terminal ID" title="Terminal ID" />
            <ColumnDefinition
              id="Note"
              title="Note"
              customComponent={AmountColumn}
            />
            <ColumnDefinition id="Type" title="Type" />
            <ColumnDefinition id="Deposit Count" title="Deposit Count" />
            <ColumnDefinition id="Date Range" title="Date Range" />
          </RowDefinition>
        );
      } else {
        tableRowDef = (
          <RowDefinition>
            <ColumnDefinition id="Terminal ID" title="Terminal ID" />
            <ColumnDefinition
              id="Note"
              title="Note"
              customComponent={AmountColumn}
            />
            <ColumnDefinition id="Type" title="Type" />
            <ColumnDefinition id="Deposit Count" title="Deposit Count" />
            <ColumnDefinition id="Dispense Count" title="Dispense Count" />
            <ColumnDefinition id="Difference" title="Difference" />
            <ColumnDefinition id="Date Range" title="Date Range" />
          </RowDefinition>
        );
      };
    }

    if (tableType === "Detail_Report") {
      if (this.state.isKisanReport === true) {
        tableRowDef = (
          <RowDefinition>
            <ColumnDefinition id="Terminal Name" title="Terminal Name" />
            <ColumnDefinition id="User Name" title="User Name" />
            <ColumnDefinition id="Trans ID" title="Trans ID" />
            <ColumnDefinition
              id="Transaction Time"
              title="Transaction Time"
              customComponent={DateColumn}
            />

            <ColumnDefinition id="Trans Name" title="Trans Name" />
            <ColumnDefinition
              id="Transaction Amount"
              title="Amount"
              customComponent={AmountColumn}
            />
            <ColumnDefinition id="Hundreds" title="Hundreds" />
            <ColumnDefinition id="Fifties" title="Fifties" />
            <ColumnDefinition id="Twenties" title="Twenties" />
            <ColumnDefinition id="Tens" title="Tens" />
            <ColumnDefinition id="Fives" title="Fives" />
            {/* <ColumnDefinition id="Twos" title="Twos" /> */}
            <ColumnDefinition id="Ones" title="Ones" />
          </RowDefinition>
        );
      } else {
        tableRowDef = (
          <RowDefinition>
            <ColumnDefinition id="Terminal ID" title="Terminal ID" />
            <ColumnDefinition
              id="Business Date"
              title="Business Date"
              customComponent={DateOnlyColumn}
            />
            <ColumnDefinition
              id="Transaction Time"
              title="Transaction Time"
              customComponent={DateColumn}
            />
            <ColumnDefinition id="Trans ID" title="Trans ID" />
            <ColumnDefinition id="Trans Name" title="Trans Name" />
            <ColumnDefinition id="Reject Type" title="Reject Type" />
            <ColumnDefinition
              id="Transaction Amount"
              title="Amount"
              customComponent={AmountColumn}
            />
            <ColumnDefinition id="Hundreds" title="Hundreds" />
            <ColumnDefinition id="Fifties" title="Fifties" />
            <ColumnDefinition id="Twenties" title="Twenties" />
            <ColumnDefinition id="Tens" title="Tens" />
            <ColumnDefinition id="Fives" title="Fives" />
            <ColumnDefinition id="Twos" title="Twos" />
            <ColumnDefinition id="Ones" title="Ones" />
            <ColumnDefinition id="Dollar Coins" title="Dollar Coins" />
            <ColumnDefinition id="Half Dollars" title="Half Dollars" />
            <ColumnDefinition id="Quarters" title="Quarters" />
            <ColumnDefinition id="Dimes" title="Dimes" />
            <ColumnDefinition id="Nickels" title="Nickels" />
            <ColumnDefinition id="Pennies" title="Pennies" />
          </RowDefinition>
        );
      }
    }

    if (tableType === "Forced_Notes") {
      tableRowDef = (
        <RowDefinition>
          <ColumnDefinition id="Terminal ID" title="Terminal ID" />
          <ColumnDefinition id="Register Name" title="Register Name" />
          <ColumnDefinition id="User Name" title="User Name" />
          <ColumnDefinition
            id="Business Date"
            title="Business Date"
            customComponent={DateOnlyColumn}
          />
          <ColumnDefinition
            id="Transaction Time"
            title="Transaction Time"
            customComponent={DateColumn}
          />
          <ColumnDefinition id="Trans ID" title="Trans ID" />
          <ColumnDefinition id="Trans Name" title="Trans Name" />
          <ColumnDefinition id="Reject Type" title="Reject Type" />
          <ColumnDefinition
            id="Forced Amount"
            title="Forced Amount"
            customComponent={AmountColumn}
          />
        </RowDefinition>
      );
    }

    if (tableType === "Grand_Totals") {
      tableRowDef = (
        <RowDefinition>
          <ColumnDefinition id="Recycler ID" title="Recycler ID" />
          <ColumnDefinition id="Cassette" title="Cassette" />
          <ColumnDefinition id="Cash Unit Type" title="Cassette Type" />
          <ColumnDefinition id="Note" title="Note" />

          <ColumnDefinition id="Quantity" title="Quantity" />
          <ColumnDefinition
            id="Amount"
            title="Amount"
            customComponent={AmountColumn}
          />
          <ColumnDefinition id="Capacity" title="Capacity" />
          <ColumnDefinition
            id="Last Transaction"
            title="Last Transaction"
            customComponent={DateColumn}
          />
        </RowDefinition>
      );
    }

    if (tableType === "End_Of_Day_Totals") {
      tableRowDef = (
        <RowDefinition>
          <ColumnDefinition id="Recycler ID" title="Recycler ID" />
          <ColumnDefinition id="Cassette" title="Cassette" />
          <ColumnDefinition id="Note" title="Note" />
          <ColumnDefinition id="Quantity" title="Quantity" />
          <ColumnDefinition
            id="Amount"
            title="Amount"
            customComponent={AmountColumn}
          />
          <ColumnDefinition id="Capacity" title="Capacity" />
          <ColumnDefinition id="Cash Unit Type" title="Cassette Type" />
          <ColumnDefinition
            id="Business Date"
            title="Business Date"
            customComponent={DateOnlyColumn}
          />
        </RowDefinition>
      );
    }

    if (tableType === "Balance_Report") {
      // define register summary
      tableRowDef = (
        <RowDefinition>
          <ColumnDefinition id="Register ID" title="Register ID" />
          <ColumnDefinition id="Register Name" title="Register Name" />
          <ColumnDefinition id="User ID" title="User ID" />
          <ColumnDefinition id="User Name" title="User Name" />
          <ColumnDefinition
            id="Deposit Amount"
            title="Deposit Amount"
            customComponent={AmountColumn}
          />
          <ColumnDefinition
            id="Dispense Amount"
            title="Dispense Amount"
            customComponent={AmountColumn}
          />
          <ColumnDefinition
            id="Net Total"
            title="Net Total"
            customComponent={AmountColumn}
          />
          <ColumnDefinition
            id="Business Date"
            title="Business Date"
            customComponent={DateOnlyColumn}
          />
        </RowDefinition>
      );
    }

    if (tableType === "Misc_Media") {
      tableRowDef = (
        <RowDefinition>
          <ColumnDefinition id="Terminal ID" title="Terminal ID" />
          <ColumnDefinition id="Register ID" title="Register ID" />
          <ColumnDefinition id="User Name" title="User Name" />
          <ColumnDefinition id="Transaction Name" title="Transaction Name" />
          <ColumnDefinition id="Transaction ID" title="Transaction ID" />
          <ColumnDefinition
            id="Business Date"
            title="Business Date"
            customComponent={DateOnlyColumn}
          />
          <ColumnDefinition
            id="Transaction Time"
            title="Transaction Time"
            customComponent={DateColumn}
          />
          <ColumnDefinition id="Unit ID" title="Media Type" />
          <ColumnDefinition id="Quantity" title="Quantity" />
          <ColumnDefinition
            id="Amount"
            title="Amount"
            customComponent={AmountColumn}
          />
        </RowDefinition>
      );
    }

    if (tableType === "Notes_Report") {
      tableRowDef = (
        <RowDefinition>
          <ColumnDefinition id="Terminal ID" title="Terminal ID" />
          <ColumnDefinition id="Notes" title="Notes" />
          <ColumnDefinition id="Avg Per Day" title="Avg Per Day" />
          <ColumnDefinition id="Date Range" title="Date Range" />
        </RowDefinition>
      );
    }

    if (tableType === "Open_Till") {
      tableRowDef = (
        <RowDefinition>
          <ColumnDefinition id="User ID" title="User ID" />
          <ColumnDefinition id="User Name" title="User Name" />
          <ColumnDefinition id="Register ID" title="Register ID" />
          <ColumnDefinition id="Register Name" title="Register Name" />
          <ColumnDefinition id="Transaction Name" title="Transaction Name" />
          <ColumnDefinition id="Transaction ID" title="Transaction ID" />
          {/* <ColumnDefinition id="Terminal ID" title="Terminal ID" /> */}
          <ColumnDefinition
            id="Transaction Time"
            title="Transaction Time"
            customComponent={DateColumn}
          />
        </RowDefinition>
      );
    }

    if (tableType === "Register_Profile") {
      tableRowDef = (
        <RowDefinition>
          <ColumnDefinition id="Register ID" title="Register ID" />
          <ColumnDefinition id="Register Name" title="Register Name" />
          <ColumnDefinition id="Deposit Functions" title="Deposit Function" />
          <ColumnDefinition id="Dispense Functions" title="Dispense Function" />
          <ColumnDefinition
            id="Functions List"
            title="Function List"
            width={300}
          />
        </RowDefinition>
      );
    }

    if (tableType === "Register_Summary") {
      tableRowDef = (
        <RowDefinition>
          <ColumnDefinition id="Register ID" title="Register ID" />
          <ColumnDefinition id="Register Name" title="Register Name" />
          <ColumnDefinition
            id="Deposit Amount"
            title="Deposit Amount"
            customComponent={AmountColumn}
          />
          <ColumnDefinition
            id="Dispense Amount"
            title="Dispense Amount"
            customComponent={AmountColumn}
          />
          <ColumnDefinition
            id="Total Amount"
            title="Total Amount"
            customComponent={AmountColumn}
          />
          <ColumnDefinition
            id="Business Date"
            title="Business Date"
            customComponent={DateOnlyColumn}
          />
        </RowDefinition>
      );
    }

    if (tableType === "Terminal_Summary") {
      if (this.state.isKisanReport === true) {
        tableRowDef = (
          <RowDefinition>
            <ColumnDefinition id="Terminal Name" title="Terminal Name" />
            <ColumnDefinition
              id="Total Amount"
              title="Total Amount"
              customComponent={AmountColumn}
            />
            <ColumnDefinition id="Date Range" title="Date Range" />
          </RowDefinition>
        );
      } else {
        tableRowDef = (
          <RowDefinition>
            <ColumnDefinition id="Terminal ID" title="Terminal ID" />
            <ColumnDefinition id="Terminal Name" title="Terminal Name" />
            <ColumnDefinition
              id="Dispense Amount"
              title="Dispense Amount"
              customComponent={AmountColumn}
            />
            <ColumnDefinition
              id="Deposit Amount"
              title="Deposit Amount"
              customComponent={AmountColumn}
            />
            <ColumnDefinition
              id="Total Amount"
              title="Total Amount"
              customComponent={AmountColumn}
            />
            <ColumnDefinition id="Date Range" title="Date Range" />
          </RowDefinition>
        );
      }
    }

    if (tableType === "Till_Profile") {
      tableRowDef = (
        <RowDefinition>
          <ColumnDefinition
            id="Cash Recycler Type"
            title="Cash Recycler Type"
          />
          <ColumnDefinition id="Function Name" title="Function Name" />
          <ColumnDefinition id="Function Level" title="Function Level" />
          <ColumnDefinition id="Function Type" title="Function Type" />

          <ColumnDefinition
            id="Chained Transaction"
            title="Chained Transaction"
          />
          <ColumnDefinition
            id="Note Configuration"
            title="Note Configuration"
          />
        </RowDefinition>
      );
    }

    if (tableType === "Transaction_Log") {
      if (this.state.isKisanReport === true) {
        tableRowDef = (
          <RowDefinition>
            <ColumnDefinition id="Terminal Name" title="Terminal Name" />
            <ColumnDefinition id="User Name" title="User Name" />
            <ColumnDefinition id="Transaction ID" title="Trans ID" />
            <ColumnDefinition
              id="Transaction Time"
              title="Transaction Time"
              customComponent={DateColumn}
            />
            <ColumnDefinition id="Transaction Name" title="Trans Name" />
            <ColumnDefinition
              id="Transaction Amount"
              title="Transaction Amount"
              customComponent={AmountColumn}
            />
          </RowDefinition>
        );
      }
      else {
        tableRowDef = (
          <RowDefinition>
            <ColumnDefinition id="User Name" title="User Name" />
            <ColumnDefinition id="Register Name" title="Register Name" />
            <ColumnDefinition id="Terminal Name" title="Terminal Name" />
            <ColumnDefinition id="Function Level" title="Function Level" />
            <ColumnDefinition
              id="Business Date"
              title="Business Date"
              customComponent={DateOnlyColumn}
            />
            <ColumnDefinition
              id="Transaction Time"
              title="Transaction Time"
              customComponent={DateColumn}
            />
            <ColumnDefinition id="Transaction ID" title="Trans ID" />
            <ColumnDefinition id="Transaction Name" title="Trans Name" />
            <ColumnDefinition
              id="Transaction Amount"
              title="Transaction Amount"
              customComponent={AmountColumn}
            />
          </RowDefinition>
        );
      }
    }

    if (tableType === "Vault_Transaction_Log") {
      tableRowDef = (
        <RowDefinition>
          <ColumnDefinition id="Vault ID" title="Vault ID" />
          <ColumnDefinition id="Transaction ID" title="Trans ID" />
          <ColumnDefinition id="Transaction Name" title="Trans Name" />
          <ColumnDefinition id="User Name" title="User Name" />
          <ColumnDefinition
            id="Business Date"
            title="Business Date"
            customComponent={DateOnlyColumn}
          />
          <ColumnDefinition
            id="Transaction Time"
            title="Transaction Time"
            customComponent={DateColumn}
          />
          <ColumnDefinition
            id="Transaction Amount"
            title="Transaction Amount"
            customComponent={AmountColumn}
          />
          <ColumnDefinition id="Hundreds" title="Hundreds" />
          <ColumnDefinition id="Fifties" title="Fifties" />
          <ColumnDefinition id="Twenties" title="Twenties" />
          <ColumnDefinition id="Tens" title="Tens" />
          <ColumnDefinition id="Fives" title="Fives" />
          <ColumnDefinition id="Twos" title="Twos" />
          <ColumnDefinition id="Ones" title="Ones" />
          <ColumnDefinition id="Dollar Coins" title="Dollar Coins" />
          <ColumnDefinition id="Half Dollars" title="Half Dollars" />
          <ColumnDefinition id="Quarters" title="Quarters" />
          <ColumnDefinition id="Dimes" title="Dimes" />
          <ColumnDefinition id="Nickels" title="Nickels" />
          <ColumnDefinition id="Pennies" title="Pennies" />
        </RowDefinition>
      );
    }

    if (tableType === "User_Profile") {
      tableRowDef = (
        <RowDefinition>
          <ColumnDefinition id="User Id" title="User ID" />
          <ColumnDefinition id="User Name" title="User Name" />
          <ColumnDefinition id="User Level" title="User Level" />
          <ColumnDefinition
            id="Date Created"
            title="Date Created"
            customComponent={DateOnlyColumn}
          />
          <ColumnDefinition
            id="Dispense Limit"
            title="Dispense Limit"
            customComponent={AmountColumn}
          />
          <ColumnDefinition
            id="Prompt for Bus Date"
            title="Prompt for Bus Date"
          />
          <ColumnDefinition id="Locked Out" title="Locked Out" />
          <ColumnDefinition
            id="Last Login"
            title="Last Login"
            customComponent={DateColumn}
          />
          <ColumnDefinition id="Deleted" title="Deleted" />
          <ColumnDefinition id="Registers" title="Registers" />
        </RowDefinition>
      );
    }

    if (tableType === "User_Summary") {
      if (this.state.isKisanReport === true) {
        tableRowDef = (
          <RowDefinition>
            <ColumnDefinition id="User ID" title="User ID" />
            <ColumnDefinition id="User Name" title="User Name" />
            <ColumnDefinition
              id="Business Date"
              title="Business Date"
              customComponent={DateOnlyColumn}
            />
            <ColumnDefinition
              id="Total Amount"
              title="Total Amount"
              customComponent={AmountColumn}
            />
          </RowDefinition>
        );
      } else {
        tableRowDef = (
          <RowDefinition>
            <ColumnDefinition id="User ID" title="User ID" />
            <ColumnDefinition id="User Name" title="User Name" />
            <ColumnDefinition id="Register Name" title="Register Name" />
            <ColumnDefinition
              id="Business Date"
              title="Business Date"
              customComponent={DateOnlyColumn}
            />
            <ColumnDefinition
              id="Deposit Amount"
              title="Deposit Amount"
              customComponent={AmountColumn}
            />
            <ColumnDefinition
              id="Dispense Amount"
              title="Dispense Amount"
              customComponent={AmountColumn}
            />
            <ColumnDefinition
              id="Total Amount"
              title="Total Amount"
              customComponent={AmountColumn}
            />
          </RowDefinition>
        );
      }
      
    }

    if (tableType === "Error_Log") {
      tableRowDef = (
        <RowDefinition>
          <ColumnDefinition id="Log ID" title="Log ID" />
          <ColumnDefinition id="Recycler ID" title="Recycler ID" />
          <ColumnDefinition id="Recycler Name" title="Recycler Name" />
          <ColumnDefinition id="Error Code" title="Error Code" />
          <ColumnDefinition id="Error Description" title="Error Description" />
          <ColumnDefinition id="Log Date" title="Log Date" />
        </RowDefinition>
      );
    }

    if (tableType === "Provisional_Credit") {
      tableRowDef = (
        <RowDefinition>
          <ColumnDefinition id="TerminalName" title="Terminal Name" />
          <ColumnDefinition id="SafeID" title="Safe ID" />
          <ColumnDefinition id="TranType" title="Transaction Type" />
          <ColumnDefinition id="CurrencyType" title="Currency Type" />
          <ColumnDefinition id="ActivityDate" title="Activity Date" />
          <ColumnDefinition id="TranDate" title="Transaction Date" />
          <ColumnDefinition id="SequenceNumber" title="Sequence Number" />
          <ColumnDefinition id="Total" title="Total" />
        </RowDefinition>
      );
    }

    let dataCol = <div />;

    if (this.state.tableData.length > 0) {
      const fields = Object.keys(tableData[0]);
      dataCol = fields.map((fieldName) => {
        //fieldName = fieldName.replace(/_/g, " ");
        //fieldName = fieldName.toUpperCase();
        return (
          <ExcelColumn key={fieldName} label={fieldName} value={fieldName} />
        );
      });
    }

    // TODO: [SBO-85] add "pro" version column to location table, fetch data from there rather than hard coded.  true --> show excel export, false --> hide
    let locationIsPro = false;
    let excelButton = null;
    if (locationIsPro) {
      excelButton = (
        <GridItem xs={12} sm={12} md={4}>
          <ExcelFile
            element={<Button color="success">Export EXCEL</Button>}
            filename={`${tableTitle}`}
          >
            <ExcelSheet data={tableData} name={tableTitle}>
              {dataCol}
            </ExcelSheet>
          </ExcelFile>
        </GridItem>
      );
    }

    if (showLoading) {
      return (
        <div>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <Card>
                <CardHeader color="success">
                  <h4 className={classes.cardTitleWhite}>{tableTitle}</h4>
                </CardHeader>
                <CardBody>
                  <ReactLoading
                    type="spin"
                    color="#000000"
                    style={{
                      width: "20%",
                      margin: "auto",
                    }}
                  />
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      );
    }

    const tableGeneratedAt = moment(new Date()).format(
      " MM/DD/YYYY [at] hh:mm A"
    );

    let reportHeader = (
      <CardHeader color="success">
        <h4 className={classes.cardTitleWhite}>{tableTitle}</h4>
        Generated on {tableGeneratedAt}
      </CardHeader>
    );
    if (tableSubTitle) {
      if (tableSubTitle.length > 0) {
        reportHeader = (
          <CardHeader color="success">
            <h4 className={classes.cardTitleWhite}>
              {tableTitle}
              {tableSubTitle}
            </h4>
            Generated on {tableGeneratedAt}
          </CardHeader>
        );
      }
    };

    return (
      <div>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              {reportHeader}

              <CardBody>
                <div className={classes.tableContainer}>
                  <Griddle
                    data={tableData}
                    plugins={[plugins.LocalPlugin]}
                    key={tableId}
                    styleConfig={styleConfig}
                    components={{
                      Layout: NewLayout,
                    }}
                    pageProperties={{
                      pageSize: 20,
                    }}
                  >
                    {tableRowDef}
                  </Griddle>
                </div>
              </CardBody>
              <CardFooter>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <Button color="success" onClick={this.handleExportCsv}>
                      Export CSV
                    </Button>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <Button color="success" onClick={this.props.handleExportPdf}>
                      Export PDF
                    </Button>
                  </GridItem>
                  {excelButton}
                </GridContainer>
              </CardFooter>
            </Card>
          </GridItem>
        </GridContainer>

        <Dialog
          fullWidth={true}
          maxWidth="md"
          open={this.props.exportPdf}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className={classes.dialogControl}
          onEnter={this.savePdf}
        >
          <div id={tableId}>
            <GridItem xs={12} sm={12} md={12}>
              <Card>
                <CardHeader color="success">
                  <h4 className={classes.cardTitleWhite}>{tableTitle}</h4>
                </CardHeader>
                <CardBody>
                  <div className={classes.tableContainer}>
                    <Griddle
                      data={tableData}
                      plugins={[plugins.LocalPlugin]}
                      key="pdfExport"
                      styleConfig={styleConfig}
                      components={{
                        Layout: PrintLayout,
                      }}
                      pageProperties={{
                        pageSize: tableData.length,
                      }}
                    >
                      {tableRowDef}
                    </Griddle>
                  </div>
                </CardBody>
              </Card>
            </GridItem>
          </div>
        </Dialog>
      </div>
    );
  }
}

ReportTable.defaultProps = {
  tableHeaderColor: "gray",
};

ReportTable.propTypes = {
  classes: PropTypes.object.isRequired,
  tableHeaderColor: PropTypes.oneOf([
    "warning",
    "primary",
    "danger",
    "success",
    "scmain",
    "info",
    "rose",
    "gray",
  ]),
  tableHead: PropTypes.arrayOf(PropTypes.string),
  tableData: PropTypes.arrayOf(PropTypes.object),
};

export default withStyles(tableStyle)(ReportTable);



// WEBPACK FOOTER //
// ./src/components/Table/ReportTable.jsx